<div class="flex flex-col" [class.gap-lg]="floating()">
  @if (activeInsights().length) {
    @if (floating()) {
      <lib-insights-panel>
        @for (item of activeInsights(); track item.label) {
          <lib-stat
            [label]="item.value.toString()"
            [overline]="item.label | transloco"
            [iconSvgName]="item.iconName || 'info'" />
        }
      </lib-insights-panel>
    } @else {
      <div
        class="mt-2xl w-full grid [grid-template-columns:repeat(auto-fill,minmax(23rem,1fr))] gap-lg">
        @for (item of activeInsights(); track item.label) {
          <div>
            <lib-stat
              [label]="item.value.toString()"
              [overline]="item.label | transloco"
              [iconSvgName]="item.iconName || 'info'" />
          </div>
        }
      </div>
    }
  }

  <ng-template #subTabs>
    <div class="flex items-center gap-md">
      <button
        type="button"
        [class]="assignedTabClass()"
        (click)="selectSubTab(inboxTabRoutingParam.assignedToMe)">
        {{ 'my_inbox_screen_first_tab_label' | transloco }}
      </button>
      <button
        type="button"
        [class]="delegatedTabClass()"
        (click)="selectSubTab(inboxTabRoutingParam.taskDelegation)">
        {{ 'my_inbox_screen_task_delegation_tab_label' | transloco }}
      </button>
    </div>
  </ng-template>

  @if (isAssignedTab()) {
    <lib-assigned-to-me
      [showInsights]="false"
      [headerStartTemplate]="subTabs"
      (insightsChange)="onInsightsChange($event)" />
  } @else {
    <lib-delegated-to-me
      [showInsights]="false"
      [headerStartTemplate]="subTabs"
      (insightsChange)="onInsightsChange($event)" />
  }
</div>
